import type { FieldPolicy } from '@apollo/client';

export const mergeIncomingNullToZeroPolicy = {
  merge(existing, incoming) {
    return incoming ?? existing ?? 0;
  },
} as FieldPolicy<number, number | null, number>;
